import React, { Component } from 'react';
import FooterWeb from './Footerweb';
import Headerweb from './Headerweb';
import emailjs from 'emailjs-com';
// import Topmove from '../Common/pages/Topmove';

import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';
// import { setClass1Hide } from '../Redux/CreateSlice';

class ContactUs extends Component {

   constructor(props) {
  super(props);
  this.formRef = React.createRef();
  this.state = {
    showPopup: false
  };
}
    sendEmail = (e) => {
  e.preventDefault();
  

  emailjs.sendForm(
    'service_lvclpbx', 'template_zfjaicu', e.target, 'kT6ORPohwvD0XND27'
  ).then(
    (result) => {
      toast.success(" Your message has been sent successfully!", {
        className: "toast-success"
      });
      this.formRef.current.reset();
    },
    (error) => {
      toast.error(" Failed to send message. Please try again.", {
        className: "toast-error"
      });
    }
  );
};


    render() {
        

        return (
            <div className='contact-section'>
                <Helmet>
                    <title>Contact KlinicQ | Request Demo & Support</title>
                    <meta 
                        name="description" 
                        content="Contact KlinicQ to request a free demo, inquire about hospital management software, or get technical support for your clinic or hospital." 
                    />
                      <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "@id": "https://www.klinicq.com/contact",
      "url": "https://www.klinicq.com/contact",
      "name": "Contact KlinicQ",
      "description": "Get in touch with the KlinicQ support team today. Ask about our hospital management software, request a free demo, or get technical help for your medical clinic.",
      "mainEntity": {
        "@type": "Organization",
        "name": "KlinicQ",
        "url": "https://www.klinicq.com",
        "logo": "https://www.klinicq.com/logo.png",
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "info@nucleosws.com",
            "availableLanguage": ["English"],
            "areaServed": "IN"
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "email": "sales@klinicq.com",
            "availableLanguage": ["English"],
            "areaServed": "IN"
          }
        ]
      }
    }
    `}
  </script>
                </Helmet>
                <Headerweb/>
            
                 <div className='sub-banner text-center'>
                <h1>Contact Us</h1>
                <p>Contact us today using this form and our support team will reach out as soon as possible.</p>
            </div>
            <hr className='m-0' style={{ color: '#D9F4FF' }} />
            <section className='container-90  py-0 pt-0'>
                <div className='row m-0 pb-5 align-self-center justify-content-center'>
                    <div className='col-lg-4 col-md-6 col-12 text-center'>
                        <div className='card-section'>
                            <span className='icon-circle'>
                            {/* <FontAwesomeIcon icon={faMapLocation} style={{ color: '#FFF' }} /> */}
                            {/* <img src= {require("../../src/assets/images/website/book1.png")} style={{ color: '#FFF' }}/> */}
                            <i class="fa-solid fa-location-dot fa-2xl mt-4" style={{ color: '#FFF' }} aria-hidden="true"></i>
                            </span>
   
                            <h1>Our Location</h1>
                            {/* <p>131, Rashtriya Vidyalaya Rd, Vishweshwarapura, <br/>Basavanagudi, Bengaluru, Karnataka 560004</p> */}
                            <p>514 A,Min Nagar, Panickampatti Post <br/>Palladam,Tiruppur,TamilNadu-641664</p>
                        </div>

                    </div>
                    <div className='col-lg-4 col-md-6 col-12 my-lg-0 my-md-0 my-2 text-center '>
                        <div className='card-section'>
                        <span className='icon-circle'>
                        {/* <FontAwesomeIcon icon={faEnvelope} style={{ color: '#FFF' }} /> */}
                        <i class="fa-solid fa-envelope fa-2xl mt-4" style={{ color: '#FFF' }} aria-hidden="true"></i>
                        </span>
                    
                            <h1>Our Email Address</h1>
                            <p>info@nucleosws.com</p>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-12 text-center my-lg-0 my-md-2'>
                        <div className='card-section'>
                        <span className='icon-circle'>
                        {/* <FontAwesomeIcon icon={faMobile} style={{ color: '#FFF' }} /> */}
                        <i class="fa-solid fa-phone fa-2xl mt-4" style={{ color: '#FFF' }} aria-hidden="true"></i>
                        </span>
                            <h1>Our Phone Number</h1>
                            <p>+91 8015774643
                            </p>
                        </div>
                    </div>

                </div>
                <div className='row m-0'>
                    <div className='col-lg-6 col-12'>
                

                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.2999410087273!2d77.57502788110729!3d12.952648982725313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15e8d9e80459%3A0x1895528330682b65!2s131%2C%20Rashtriya%20Vidyalaya%20Rd%2C%20Vishweshwarapura%2C%20Basavanagudi%2C%20Bengaluru%2C%20Karnataka%20560004!5e0!3m2!1sen!2sin!4v1718691093610!5m2!1sen!2sin" width="100%" height="900" style={{ border: 0, width: '100%' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                        {/* <iframe 
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.476483123456!2d77.2860946!3d10.9951819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9abcfa6d05f25%3A0xcdf11a6d1b63a898!2s514%20A%2C%20Min%20Nagar%2C%20Palladam%2C%20Tamil%20Nadu%20641664!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
  width="100%" 
  height="900" 
  style={{ border: 0 }} 
  allowFullScreen="" 
  loading="lazy" 
  referrerPolicy="no-referrer-when-downgrade">
</iframe> */}
<iframe
  title="KlinicQ office location in Palladam Tamil Nadu"
  aria-label="Map showing KlinicQ office location in Palladam, Tamil Nadu"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.476483123456!2d77.2860946!3d10.9951819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9abcfa6d05f25%3A0xcdf11a6d1b63a898!2s514%20A%2C%20Min%20Nagar%2C%20Palladam%2C%20Tamil%20Nadu%20641664!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
  width="100%"
  height="900"
  style={{ border: 0 }}
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>

                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='form-content'>
                            <h6>Get in Touch</h6>
                            <p>Contact us today using this form and our support team will reach out as soon as possible.</p>
                            <form ref={this.formRef} onSubmit={this.sendEmail} >
                                <div className="row m-0">
                                    <div className="col-md-12">
                                    
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="user_name"
                                            placeholder="Name"
                                            aria-label="Your full name"
                                            required
                                            />
                                    </div>
                                    {/* <div className="col-md-6">
                                   
                                        <input type="text" className="form-control" name="last_name" id="your-surname" placeholder="Last name" required />
                                    </div> */}
                                    <div className="col-md-12">
                                    
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="user_email"
                                            placeholder="Email"
                                            aria-label="Your email address"
                                            required
                                            />
                                    </div>
                                    <div className="col-md-12">
                                      
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone"
                                            placeholder="Phone number"
                                            aria-label="Your phone number"
                                            />
                                    </div>
                                    <div className="col-12">
                                       
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            placeholder="How can we help?"
                                            aria-label="Your message to KlinicQ support team"
                                            rows="5"
                                            required
                                            ></textarea>
                                    </div>
                                </div>
                                <div className='check-section'>
                                    <h1>Services</h1>
                                    <input type='checkbox' name="service_hospital" aria-label="Hospital management software service"/> <span>Hospital Mangement</span><br />
                                    <input type='checkbox' name="service_clinic" aria-label="Doctor management software service" className='' /> <span>Doctor Mangement</span><br />
                                    <input type='checkbox' name="service_user" aria-label="User management system service" className='mt-3' /> <span>User Mangement</span>
                                </div>
                               
                                <div className='agree-section'>
                                    <div className='d-flex'>
                                        <div className=''>
                                            <input type="checkbox" name="consent" value="Agreed" id="myCheckbox" />
                                            <label for="myCheckbox" class="custom-checkbox"></label>
                                        </div>
                                        <div className='ps-2'>
                                            <p className='p-0'>By signing up, you accept our <span className='policy'>privacy policy</span>. your contact information will only be used within Medesk and will never be shared with third parties.</p>

                                        </div>
                                    </div>
                                </div>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
  {/* <button style={{ padding: '6px 12px', height: '52px', width: '200px' }}>
    Send Message */}
    {/* <FontAwesomeIcon icon={faArrowRight} style={{ color: '#FFF', marginLeft: '2px' }} /> */}
  {/* </button> */}
  <button type="submit" style={{ padding: '6px 12px', height: '52px', width: '200px' }}>
  Send Message
</button>
   <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

</div>


                            </form>
                        </div>
                    </div>
                </div>
                
            </section>
            <Topmove />
            <FooterWeb className="qrCodeFooter" />
            </div>
                   );
                }
            }
            
            export default (ContactUs);            